import { handleResponse, handleError, headerset } from "../apiUtils";
import {Ostacolo} from "components/main/ostacoli/ostacoliSlice";
import { FiltriOstacoli } from "components/userPreference/userPreferenceSlice";
import {convertToDateTime} from "../../components/common/dateUtils/convertToDateTime";

// ============================================
// BASE URL
// ============================================

const baseUrl = (ostacoloId?: number | null) => {
    let url: string = process.env.API_URL + "/api/schedulazione/ostacoli/";

    if (ostacoloId) {
        url += ostacoloId + "/";
    }

    return url;
};

// ============================================
// QUERY STRING BUILDER
// ============================================

const buildQueryString = (filtri: FiltriOstacoli): string => {
    const params = new URLSearchParams();

    // ========== FILTRI SPECIFICI ==========

    if (filtri.tipi && filtri.tipi.length > 0) {
        params.append("tipi", filtri.tipi.join(","));
    }

    if (filtri.risolto !== undefined && filtri.risolto !== null) {
        params.append("risolto", filtri.risolto.toString());
    }

    if (filtri.data_da) {
        params.append("data_da", filtri.data_da);
    }

    if (filtri.data_a) {
        params.append("data_a", filtri.data_a);
    }

    if (filtri.odpId) {
        params.append("odpId", filtri.odpId.toString());
    }

    // ========== PAGINAZIONE E RICERCA (sempre presenti) ==========

    if (filtri.page) {
        params.append("page", filtri.page.toString());
    }
    if (filtri.numero_record) {
        params.append("numero_record", filtri.numero_record.toString());
    }
    if (filtri.search) {
        params.append("search", filtri.search);
    }

    return params.toString();
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch lista paginata di Ostacoli
 */
export function fetchOstacoli(filtri: FiltriOstacoli = {}) {
    let url = baseUrl();
    const queryString = buildQueryString(filtri);
    if (queryString) {
        url += `?${queryString}`;
    }

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Get singolo Ostacolo by ID
 */
export function getOstacolo(ostacoloId: number) {
    const url = baseUrl(ostacoloId);

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Save (create/update) Ostacolo
 */
export function saveOstacolo(ostacoloToSave: Ostacolo) {
    const ostacolo:Ostacolo = {
        ...ostacoloToSave,
        data_prevista_risoluzione: ostacoloToSave.data_prevista_risoluzione
            ? convertToDateTime(ostacoloToSave.data_prevista_risoluzione)?.setLocale("it").toFormat("yyyy-MM-dd")
            : null,

    }
    return fetch(baseUrl(ostacoloToSave.id), {
        method: ostacoloToSave.id ? "PUT" : "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },



        body: JSON.stringify({
            ...ostacolo,
            // Pulire campi display/computed prima dell'invio
            odp_display: undefined,
            codice_articolo: undefined,
            nome_cliente: undefined,
            tipo_display: undefined,
            data_segnalazione: undefined,
            is_scaduto: undefined,
            giorni_ritardo: undefined,
            errorsStack: undefined,
        }),
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Delete Ostacolo (soft delete)
 */
export function deleteOstacolo(ostacoloToDelete: Ostacolo) {
    return fetch(baseUrl(ostacoloToDelete.id), {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}
